import i18n from 'i18n-js';

import C from '../constants';

const { PHOTOAI } = C.AFILIATES;

export const BASEBALL_TEMPLATES_TITLES = {
  BASEBALL_MLB: 'baseball-mlb',
  BASEBALL_SIMPLE: 'baseball-simple',
};

export const BASEBALL_TEMPLATES_IMAGES = {
  [BASEBALL_TEMPLATES_TITLES.BASEBALL_MLB]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-mlb-1.webp',
  [BASEBALL_TEMPLATES_TITLES.BASEBALL_SIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-simple-1.webp',
};

export const BASEBALL_TEMPLATES = {
  baseball: [
    {
      category: i18n.t('screens.templates.baseball.title'),
      description: i18n.t('screens.templates.baseball.mlb.description'),
      shortDescription: i18n.t(
        'screens.templates.baseball.mlb.shortDescription'
      ),
      id: BASEBALL_TEMPLATES_TITLES.BASEBALL_MLB,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-mlb-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-mlb-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-mlb-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-mlb-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.baseball.mlb.title'),
      tier: 'pro',
      users: 0,
    },
    {
      category: i18n.t('screens.templates.baseball.title'),
      description: i18n.t('screens.templates.baseball.simple.description'),
      shortDescription: i18n.t(
        'screens.templates.baseball.simple.shortDescription'
      ),
      id: BASEBALL_TEMPLATES_TITLES.BASEBALL_SIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-simple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-simple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-simple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/baseball-simple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.baseball.simple.title'),
      tier: 'basic',
      users: 133,
    },
  ],
};

export default {
  BASEBALL_TEMPLATES,
  BASEBALL_TEMPLATES_IMAGES,
  BASEBALL_TEMPLATES_TITLES,
};
